const uploadMessage = {
  click: 'Clique ou Arraste arquivos aqui...',
  error: 'Arquivo não suportado',
  success: 'Solte os arquivos aqui'
};

export default uploadMessage;
